import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

export const RevenueDonut = ({ value }) => {
  const data = [
    { name: 'Revenue', value },
    { name: 'Remaining', value: value * 0.25 },
  ];

  const COLORS = ['#f97316', '#fde7d3'];

  return (
    <ResponsiveContainer width="100%" height={260}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={90}
          paddingAngle={5}
          dataKey="value"
        >
          {data.map((entry, i) => (
            <Cell key={i} fill={COLORS[i]} />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
};
